import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const files = require.context('.', false, /\.js$/)
const modules = {}

files.keys().forEach((key) => {
  if (key === './index.js') return
  
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

const persistedStates={
  paths:[
    'auth', 'header'
  ]
}

export default new Vuex.Store({
    modules: modules,
    plugins: [
      createPersistedState(persistedStates)
    ],
})